"use client";
import {
  ripple_default
} from "./chunk-YR7VAZRR.mjs";
import {
  useRipple
} from "./chunk-MCG5YV3A.mjs";
export {
  ripple_default as Ripple,
  useRipple
};
